import storeBikeQueries from "$/lib/queries/store-bike-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { getStoreBikeName } from "@repo/common"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const paramsSchema = z.object({
  bikeId: z.string().uuid(),
})

export const Route = createFileRoute(
  "/(app)/_auth/customers/$customerId/bikes/$bikeId",
)({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ bikeId }) => ({ bikeId: `${bikeId}` }),
  },
  loader: async ({ context: { queryClient }, params }) => {
    await requireNonFreeTier(queryClient)
    const bike = await queryClient.ensureQueryData(
      storeBikeQueries.detail(params.customerId, params.bikeId),
    )
    return {
      crumb:
        getStoreBikeName(bike) ??
        "alfred.pages.customers.bikeDetail.crumbFallback",
    }
  },
})
